// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"toggleSwitch_toggleSwitch__TGnd+","switch":"toggleSwitch_switch__4DBh-"};